import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private snackBar: MatSnackBar) { }


    /**
   * Used to display alert messages at the bottom of the screen
   * @param message 
   * @param btnText 
   * @param duration 
   * @param isError 
   */
    showSnackBarMessage(message: string, btnText:string, duration: number = 3000, isError: boolean = false){
      this.snackBar.open(message, btnText, {duration: duration, panelClass: isError ? 'snack-bar-error' : 'snack-bar-success'});
    }
}
